import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import {
  Container,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Spinner,
  Modal,
  ModalBody,
  Button, CardTitle, Form, Label
} from "reactstrap"
import classnames from "classnames"
import { withTranslation } from "react-i18next"
import { withRouter } from "react-router"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import API from "../../api"
import Select from "react-select"
import DatePicker from "react-datepicker";
import getDay from "date-fns/getDay"
import { toast } from "react-toastify"
if (localStorage.getItem("anneeScolaire")) {
  var anneeScolaire = JSON.parse(localStorage.getItem("anneeScolaire"))
  var annee = anneeScolaire.Annee.id
}
const AttestationPresence = props => {
  const [section, setSection] = useState(1)
  const [loading, setLoading] = useState(false)
  const [orders, setOrders] = useState([])
  const [modalVal, setModalVal] = useState(false)
  const [idVal, setIdVal] = useState("")
  const [niveau, setNiveau] = useState([]);
  const [selectNiveau, setSelectNiveau] = useState("")
  const [cycle, setCycle] = useState([])
  const [selectCycle, setSelectCycle] = useState("")
  const [langue, setLangue] = useState([
    { value: "fr", label: "Français" },
    { value: "ar", label: "Arabe" },
  ])
  const [selectLangue, setSelectLangue] = useState("")
  const toggleVal = id => {
    setModalVal(!modalVal)
    setIdVal(id)
  }
  const valide = async () => {
    const res = await API.post("scolarite/etudiant/demande/accept", {
      id: idVal,
    }).then(res => {
      setModalVal(!modalVal)
      const resD = API.post("scolarite/etudiant/demande/list", {
        id: 1,annee_id:annee
      }).then(resD => {
        setOrders(resD.data.Demandes)
      })
      setLoading(true)
    })
  }
  const refuse = async () => {
    const res = await API.post("scolarite/etudiant/demande/deny", {
      id: idVal,
    }).then(res => {
      setModalVal(!modalVal)
      const resD = API.post("scolarite/etudiant/demande/list", {
        id: 1,annee_id:annee
      }).then(resD => {
        setOrders(resD.data.Demandes)
      })
      setLoading(true)
    })
  }
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Next",
    prePageText: "Back",
    alwaysShowAllBtns: true,
    sizePerPage: 30,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }
  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = () => [
    {
      dataField: "date",
      text: "Date",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "code",
      text: "CIN",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "etudiant",
      text: "Etudiant",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "groupe",
      text: "Groupe",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "raison",
      text: "Raison",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "langue",
      text: "Langue",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "id",
      isDummyField: true,
      text: "Téléchargement",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
          <a href={"https://scolarite.backcresus-institut.ovh/api/impression_demande_etudiant/" +row.lang +"/" + annee+"/"+row.id }
              target="_blank"
              rel="noreferrer"
              style={{ display: "flex", justifyContent: "center" }}
          >
            <i
                style={{ color: "#955cd5", cursor: "pointer" }}
                className="fas fa-file-download"
            ></i>
          </a>
      ),
    },
    {
      dataField: "Action",
      isDummyField: true,
      text: "Action",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        row.state == 0 ? (
          <i
            style={{ color: "#143F6B", cursor: "pointer" }}
            onClick={() => toggleVal(row.id)}
            className="fas fa-cogs"
          ></i>
        ) : row.state == 2 ? (
          <i
            style={{ color: "red", cursor: "pointer" }}
            onClick={() => toggleVal(row.id)}
            className="fas fa-times"
          ></i>
        ) : (
          <i
            style={{ color: "#2ca67a", cursor: "pointer" }}
            className="fas fa-check"
          ></i>
        ),
    },
  ]
  const { SearchBar } = Search
  const [dateDebut, setDateDebut] = useState(new Date())
  const isWeekday = date => {
    const day = getDay(date)
    return day !== 0
  }
  useEffect(async () => {
    const resC = await API.get("cycle/select").then(resC => {
      setCycle(resC.data.Cycle)
    })
    const res = await API.post("scolarite/etudiant/demande/list", {
      id: 1,annee_id:annee
    }).then(res => {
      setOrders(res.data.Demandes)
    })
    setLoading(true)
  }, [])
  const getNiveau = async event => {
    var cycle_id = event.value
    setSelectCycle(event)
    setSelectNiveau("")

    if (cycle_id == 1) {
      const res = await API.get("niveau/select").then(res => {
        setNiveau(res.data.Niveau)
      })
    } else {
      const res = await API.get("niveau/select_mastere").then(res => {
        setNiveau(res.data.Niveau)
      })
    }
  }
  const search = async () => {
    const niveau_id = selectNiveau ? selectNiveau.value : 0;
    const cycle_id = selectCycle ? selectCycle.value : 0;
    const lang = selectLangue ? selectLangue.value : 0;
    // ✅ Si la date existe → on la formate
    const DateNote_debut = new Date(dateDebut);
    const year = DateNote_debut.getFullYear();
    const month = String(DateNote_debut.getMonth() + 1).padStart(2, "0");
    const day = String(DateNote_debut.getDate()).padStart(2, "0");
    const convertDate_debut = `${year}-${month}-${day}`;

    try {
      const res = await API.post("scolarite/etudiant/demande/search", {
        id: 1,
        date: convertDate_debut || 0, // si jamais bug → fallback à 0
        niveau_id,
        cycle_id,
        annee_id:annee,
        lang
      }).then(res => {
        setOrders(res.data.Demandes)
      })
    } catch (error) {
      console.error("Erreur lors de la recherche :", error);
      toast.error("❌ Une erreur est survenue lors de la recherche.", {
        containerId: "A",
      });
    }
  };

  const searchAll = async () => {
    const res = await API.post("scolarite/etudiant/demande/list", {
      id: 1,annee_id:annee
    }).then(res => {
      setOrders(res.data.Demandes)
      setDateDebut(new Date())
    })
  }
  const uploadPDF = async () => {
    const niveau_id = selectNiveau ? selectNiveau.value : 0;
    const cycle_id = selectCycle ? selectCycle.value : 0;
    const lang = selectLangue ? selectLangue.value : 0; // ✅ plus propre

    const DateNote_debut = new Date(dateDebut);
    const year = DateNote_debut.getFullYear();
    const month = String(DateNote_debut.getMonth() + 1).padStart(2, "0");
    const day = String(DateNote_debut.getDate()).padStart(2, "0");
    const convertDate_debut = `${year}-${month}-${day}`;

    window.open(
      `https://scolarite.backcresus-institut.ovh/api/fiches_presences/${lang}/${annee}/${cycle_id}/${niveau_id}/${convertDate_debut}`,
      "_blank"
    );
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Attestation De Présence | Cresus </title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 1,
                  })}
                  onClick={() => {
                    setSection(1)
                  }}
                >
                  Attestation De Présence
                </NavLink>
              </NavItem>
            </Nav>
            <Card>
              <CardBody>
                <React.Fragment>
                  <div>
                    <CardTitle style={{ color: "#556ee6" }} className="h4">
                      Critéres de Recherches
                    </CardTitle>
                    <Form className="mt-4">
                      <Row>
                        <Col lg="3">
                          <div className="mb-3">
                            <Label for="basicpill-lastname-input2">
                              Date :
                            </Label>
                            <DatePicker
                              selected={dateDebut}
                              // filterDate={isWeekday}
                              className="form-control ddate"
                              dateFormat="dd/MM/yyyy"
                              onChange={e => setDateDebut(e)}
                            />
                          </div>
                        </Col>
                        <Col lg="3">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Cycle :{" "}
                            </Label>
                            <Select
                              options={cycle}
                              isSearchable={true}
                              value={selectCycle}
                              onChange={e => getNiveau(e)}
                            />
                          </div>
                        </Col>
                        <Col lg="3">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Niveau :{" "}
                            </Label>
                            <Select
                              options={niveau}
                              isSearchable={true}
                              value={selectNiveau}
                              onChange={e => setSelectNiveau(e)}
                            />
                          </div>
                        </Col>
                        <Col lg="3">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Langue :
                            </Label>
                            <Select
                              options={langue}
                              isSearchable={true}
                              value={selectLangue}
                              onChange={e => setSelectLangue(e)}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form>
                    <div
                      className="mb-4"
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                      }}
                    >
                      {" "}
                      <Col lg="4">
                        <div className="text-center mt-4">
                          <button
                            type="button"
                            style={{
                              backgroundColor: "#761C19",
                              borderColor: "#761C19",
                            }}
                            className="btn btn-success mb-2 me-2"
                            onClick={search}
                          >
                            Rechercher
                          </button>
                        </div>
                      </Col>
                      <Col lg="4">
                        <div className="text-center mt-4">
                          <button
                            type="button"
                            style={{
                              backgroundColor: "#1f7619",
                              borderColor: "#1f7619",
                            }}
                            className="btn btn-success mb-2 me-2"
                            onClick={uploadPDF}
                          >
                            Imprimer
                          </button>
                        </div>
                      </Col>
                      <Col lg="4">
                        <div className="text-center mt-4">
                          <button
                            type="button"
                            style={{
                              backgroundColor: "#761C19",
                              borderColor: "#761C19",
                            }}
                            className="btn btn-success mb-2 me-2"
                            onClick={searchAll}
                          >
                            Afficher tout
                          </button>
                        </div>
                      </Col>
                    </div>
                    {loading ? (
                      <Row>
                        <Col xs="12">
                          <ToolkitProvider
                            keyField="id"
                            data={orders}
                            columns={Columns()}
                            search
                            bootstrap4
                          >
                            {toolkitProps => (
                              <div>
                                <Col sm="4">
                                  <div className="search-box me-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitProps.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                                <BootstrapTable
                                  wrapperClasses="table-responsive"
                                  noDataIndication={() => <NoDataIndication />}
                                  striped={false}
                                  bordered={false}
                                  classes={"table align-middle table-nowrap"}
                                  headerWrapperClasses={"table-light"}
                                  hover
                                  pagination={paginationFactory(pageOptions)}
                                  {...toolkitProps.baseProps}
                                />
                              </div>
                            )}
                          </ToolkitProvider>
                        </Col>
                      </Row>
                    ) : (
                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {" "}
                          <Spinner
                            type="grow"
                            className="ms-6"
                            color="primary"
                          />
                        </div>
                        <h4
                          style={{ textAlign: "center", marginTop: "2%" }}
                          className="ms-6"
                        >
                          {" "}
                          En Cours ...{" "}
                        </h4>
                      </div>
                    )}
                  </div>
                  <Modal isOpen={modalVal} toggle={toggleVal} centered={true}>
                    <div
                      className="modal-header"
                      style={{
                        width: "100% !important",
                        justifyContent: "center !important",
                        margin: "0 auto",
                        fontSize: "17px",
                        fontWeight: "bold",
                      }}
                      toggle={toggleVal}
                    >
                      {props.t("Validation Attestation De Présence")}
                    </div>
                    <ModalBody>
                      <div
                        style={{
                          fontFamily: "Montserrat, sans-serif",
                          FontSize: "14px",
                          FontWeight: "700",
                          LineHeight: "18.375px",
                        }}
                      >
                        <div
                          className="hvr-push"
                          style={{
                            display: "flex",
                            justifyContent: "space-around",
                            marginBottom: "15px",
                          }}
                        >
                          <div>
                            <Button
                              className="btn btn-success"
                              onClick={valide}
                            >
                              <i
                                style={{ color: "white", paddingRight: "5px" }}
                                className="fas fa-check-circle"
                              ></i>
                              {props.t("Valider")}
                            </Button>
                          </div>
                          <div>
                            <Button className="btn btn-danger" onClick={refuse}>
                              <i
                                style={{ color: "white", paddingRight: "5px" }}
                                className="fas fa-ban"
                              ></i>
                              {props.t("Refuser")}
                            </Button>
                          </div>
                          <div>
                            <Button
                              onClick={toggleVal}
                              className="btn btn-warning"
                            >
                              <i
                                style={{ color: "white", paddingRight: "5px" }}
                                className="fas fa-times-circle"
                              ></i>
                              {props.t("Annuler")}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                  </Modal>
                </React.Fragment>
              </CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(AttestationPresence))
AttestationPresence.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
